import { Platform } from "../constants";

import { ConstructDestinationUrl, URLVerification } from "./components/utms";
import { type PlatformDetails } from "./platform-details";
import { UtmSpendAdditionalDetails } from "./utm-spend-details";

const PLATFORM = Platform.CRITEO;

export const CriteoDetails: PlatformDetails = {
  northbeamDocUrl: "",
  officialDocUrl: "",
  additionalDetails: UtmSpendAdditionalDetails(PLATFORM),
};

export const CriteoSetup = () => (
  <>
    <ConstructDestinationUrl platform={PLATFORM} />
    <URLVerification platform={PLATFORM} />
  </>
);
